<template>
  <div class="d-flex justify-content-center breadcrumb-alt">
    <div
      v-for="({ label, icon }, index) in items"
      :key="`breadcrumb_item_${index}`"
      class="d-inline-flex align-items-center breadcrumb-alt-item"
      :class="{
        active: isActive(index),
        checked: isChecked(index),
      }"
    >
      <BtnIcon
        v-bind="{
          icon: isChecked(index) ? 'checked' : icon,
          active: isActive(index),
          iconSize: 16,
        }"
        @click.native="$emit('onclick', index)"
      />
      <span class="h-ml-3 h-mr-1">
        {{ label }}
      </span>
      <hr
        v-if="index + 1 < items.length"
        class="align-self-center mx-2 text-muted"
      />
    </div>
  </div>
</template>

<script>
import { prop } from '@/utils/factories';
import BtnIcon from '@/components/form/BtnIcon';
export default {
  name: 'BreadcrumbAlt',
  components: { BtnIcon },
  props: {
    items: prop(Array),
    currentStep: prop(Number, 1),
  },
  methods: {
    isActive(index) {
      return this.currentStep > index;
    },
    isChecked(index) {
      return this.currentStep - 1 > index;
    },
  },
};
</script>

<style lang="scss">
.breadcrumb-alt {
  &-item {
    hr {
      width: 4.25rem;
      border-color: $ph-input-bg;
      border-style: solid;
      border-radius: 1px;
      transition: border-color 0.3s;
    }
    &.checked {
      hr {
        border-color: $ph-accent;
      }
    }
  }
}
</style>
